<template>
  <div class="cat-options">
    <div class="container">
      <div class="row">
        <div class="col-xl-8 col-lg-7 col-md-6 col-sm-6 col-xs-12">
          <breadcrumb/>
          <DefTitle :result="1">
            <h1>{{ result.section.name }}</h1>
          </DefTitle>

        </div>
        <div class="col-xl-4 col-lg-5  col-md-6  col-sm-6  col-xs-12 align-content-center">
          <div class="cat-right-opt">
            <div class="cat-sort" v-if="$store.state.global.screenWidth>575">
              <button type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">{{params.messages.pagerSizeTitle}}</button>
              <div class="dropdown-menu dropdown-menu-right">
                <button v-for="button in obData.pagecountVariants" class="dropdown-item catalog-size" type="button" :data-size="button.size" :data-url="button.url">{{button.title}}</button>
              </div>
            </div>
            <div class="cat-sort">
              <button type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                {{params.messages.sortTitle}}
              </button>
              <div class="dropdown-menu dropdown-menu-right">
                <button v-for="button in params.sortVariants" class="dropdown-item catalog-sort" type="button" :data-url="button.url">{{button.title}}</button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="row align-content-center align-items-center" v-if="obData.filter.arResult.ITEMS.length>0">
        <div class="col-md-12 col-12">
          <div class="filterWrap">
            <div class="filter"   @click="togleFilterBlock">
              <div class="btn-filter" v-if="selectedFilters.length<=0">
                <a href="javascript:void(0);">{{ params.messages.filterTitle }}</a>
              </div>
              <div v-else class="selectedFilterTitle">
                {{params.messages.filterSelectedTitle}}:
              </div>
            </div>
            <div class="selected-filter" v-if="selectedFilters.length>0">
              <div class="selected_wrap">
                <div class="selectedItem" v-for="item in selectedFilters" @click="setDelProp(item.CONTROL_ID)">
                  {{item.VALUE}}
                  <span class="delSelectedFilter"></span>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
    <catalog-filter  v-if="obData.filter.arResult.ITEMS.length>0"
        @togleFilter="togleFilterBlock"
        :reset_without_prop="reset_without_prop"
        :mess="obData.messages"
        :params='obData.filter'/>
  </div>
</template>

<script>
import Breadcrumb from "../breadcrumb.vue";
import DefTitle from "../Def/DefTitle/DefTitle.vue";
import CatalogFilter from "./filter/index.vue";

export default {
  name: "head-section-modef",
  components: {CatalogFilter, DefTitle, Breadcrumb},
  selector: 'head-section-modef',
  props:["params", 'result'],
  data() {
    return {
      obData:this.params,
      reset_without_prop:false,
      selectedFilters:[],
      opened: false
    }
  },
  methods: {
    togleFilterBlock() {
      if(this.opened) {
        $('body').removeClass('opened-filter');
      } else {
        $('body').addClass('opened-filter');
      }
      this.opened = !this.opened;
    },
    setDelProp(key) {
      for (let propKey in this.obData.filter.arResult.ITEMS) {
        for (let valueKey in this.obData.filter.arResult.ITEMS[propKey].VALUES) {
          if(this.obData.filter.arResult.ITEMS[propKey].VALUES[valueKey].CONTROL_ID===key&&this.obData.filter.arResult.ITEMS[propKey].VALUES[valueKey].CHECKED) {
            this.obData.filter.arResult.ITEMS[propKey].VALUES[valueKey].CHECKED = false;
          }
        }
      }
      this.reset_without_prop = key;
    }
  },
  mounted() {
    for(let filterPropKey in this.params.filter.arResult.ITEMS) {
      for(let valKey in this.params.filter.arResult.ITEMS[filterPropKey].VALUES) {
        if(this.params.filter.arResult.ITEMS[filterPropKey].VALUES[valKey].CHECKED) {
          this.selectedFilters.push(this.params.filter.arResult.ITEMS[filterPropKey].VALUES[valKey]);
        }
      }
    }
  }

}
</script>

<style lang="scss" scoped>

  .cat-options {
    @media (max-width: 992px) {
      position: relative;
    }
    /*border-bottom: 0px;*/
  }

  .selectedFilterTitle {
    text-decoration: underline;
    white-space: nowrap;
    cursor: pointer;
  }
  .cat-right-opt {
    align-items: center;
    align-content: center!important;
    height: 60px;
    @media (max-width: 768px) {
      height: 35px;
    }
    @media (max-width: 350px) {
      width: 100%;
    }
  }
  .filterWrap {
    display: flex;
    flex-wrap: wrap;
    margin-bottom: 20px;
    @media (max-width: 575px) {
      margin-top: -32px;
      max-width: 50%;
    }
    @media (max-width: 350px) {
      margin-top: -27px;
    }
    .filter {
      float: none;
      margin-right: 10px;
      .btn-filter {
        display: inline-block;
      }
    }
    .selected_wrap {
      display: flex;
      flex-wrap: wrap;
      .selectedItem {
        white-space: nowrap;
        margin-right: 10px;
        padding-right: 20px;
        position: relative;
        .delSelectedFilter {
          background: url('data:image/png;base64,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');
          display: inline-block;
          width: 10px;
          height: 10px;
          background-size: contain;
          position: absolute;
          right: 5px;
          top: 50%;
          margin-top: -5px;
          cursor: pointer;
        }
      }
    }
  }
  .btn-filter {
    a {
      text-decoration: none !important;
      font-size: 10px;
      font-weight: 600;
      color: #7b7c7e;
      text-transform: uppercase;
      line-height: 18px;
      padding-right: 26px;
      display: block;
      cursor: pointer;
      background: url("data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxOSAxOC4xOCI+PHRpdGxlPmZpbHRlcjwvdGl0bGU+PGcgaWQ9IjU0ZWJjMzcyLTYwZGQtNGE1MC04M2E0LWFmNTgzYzJjMTYxZCIgZGF0YS1uYW1lPSLQodC70L7QuSAyIj48ZyBpZD0iNmIzNTMyMmQtMGE1ZS00OTBmLWE2MWYtODhmZjJjZTk0Y2M5IiBkYXRhLW5hbWU9IkxheWVyIDIiPjxsaW5lIHkxPSIxNi4wOSIgeDI9IjE5IiB5Mj0iMTYuMDkiIHN0eWxlPSJmaWxsOiMwYTEwMGY7c3Ryb2tlOiM3YzdjN2M7c3Ryb2tlLW1pdGVybGltaXQ6MTAiLz48bGluZSB5MT0iOS4wOSIgeDI9IjE5IiB5Mj0iOS4wOSIgc3R5bGU9ImZpbGw6IzBhMTAwZjtzdHJva2U6IzY3Njc2YTtzdHJva2UtbWl0ZXJsaW1pdDoxMCIvPjxsaW5lIHkxPSIyLjA5IiB4Mj0iMTkiIHkyPSIyLjA5IiBzdHlsZT0iZmlsbDojMGExMDBmO3N0cm9rZTojNjc2NzZhO3N0cm9rZS1taXRlcmxpbWl0OjEwIi8+PGxpbmUgeDE9IjMuNzQiIHkxPSIxOC4xOCIgeDI9IjMuNzQiIHkyPSIxNCIgc3R5bGU9ImZpbGw6bm9uZTtzdHJva2U6IzY3Njc2YTtzdHJva2UtbWl0ZXJsaW1pdDoxMCIvPjxsaW5lIHgxPSI4Ljc0IiB5MT0iNC4xOCIgeDI9IjguNzQiIHN0eWxlPSJmaWxsOm5vbmU7c3Ryb2tlOiM2NzY3NmE7c3Ryb2tlLW1pdGVybGltaXQ6MTAiLz48bGluZSB4MT0iMTUuMjEiIHkxPSIxMS4xOCIgeDI9IjE1LjIxIiB5Mj0iNyIgc3R5bGU9ImZpbGw6bm9uZTtzdHJva2U6IzY3Njc2YTtzdHJva2UtbWl0ZXJsaW1pdDoxMCIvPjwvZz48L2c+PC9zdmc+") right 0px no-repeat;
      -webkit-background-size: 17px;
      background-size: 17px;
      letter-spacing: 2px;
      @media (max-width: 992px) {
        font-size: 12px;
        padding: 2px 26px 2px 0;
        font-weight: bold;
        -webkit-background-size: 22px;
        background-size: 22px;
      }
      @media (max-width: 768px) {
          font-size: 10px;
          letter-spacing: normal;

      }
    }
  }
  :deep(.def-title) {
    margin-top: 20px;
    @include point-md {
      margin-top: 0;
    }
  }

  /* увеличить шрифт в 3 раза */
  div.def-title-1 h1 {
    font-size: 30px;
  }
  @media (max-width: 768px) {
    div.def-title-1 h1 {
      font-size: 30px;
    }
  }

</style>